import React from 'react';
import { motion } from 'framer-motion';
import Box from '@mui/material/Box';
import ScrollDownArrowIcon from '../img/scroll-down-arrow.svg';

const ScrollDownArrow = () => {
  return (
    <motion.div
      animate={{
        y: [0, 8, 0],
      }}
      transition={{
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }}
    >
      <Box
        component={ScrollDownArrowIcon}
        sx={{
          width: '24px',
          height: '24px',
          transform: 'rotateX(180deg)',
        }}
      />
    </motion.div>
  )
}

export default ScrollDownArrow;